import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { PROJECT_NAME } from '../../app.constants';
import { SnackbarService } from '../../core/snackbar.service';

@Component({
  selector: 'app-login',
  imports: [MatButton, MatCard, MatCardHeader, MatCardTitle, MatCardContent, TranslocoDirective],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly snackbarService = inject(SnackbarService);
  private readonly translocoService = inject(TranslocoService);

  protected readonly title = PROJECT_NAME;

  ngOnInit(): void {
    const reason = sessionStorage.getItem('logoutReason');

    if (reason === 'no-role') {
      sessionStorage.removeItem('logoutReason');
      this.translocoService
        .selectTranslate('error.forbidden')
        .pipe(take(1))
        .subscribe(message => this.snackbarService.showError(message, true));
    }
  }

  login(): void {
    this.authService.login();
  }
}
